<div class="room-page" *ngIf="!loading && meeting as room">
  <div class="room-header">
    <div>
      <p class="eyebrow">Live Meeting Room</p>
      <h2>{{ room.title }}</h2>
      <p class="subtitle">{{ room.roomType }} room · {{ room.roomName }} · {{ room.startTime | date:'medium' }}</p>
    </div>
    <div class="header-actions">
      <button mat-stroked-button (click)="copyRoomCode()">Copy Room Code</button>
      <button mat-stroked-button color="warn" (click)="leaveRoom()">Leave Room</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="joining" mode="indeterminate"></mat-progress-bar>

  <div class="room-alert danger" *ngIf="mediaError">
    <mat-icon>warning</mat-icon>
    <div>
      <strong>Media access blocked</strong>
      <small>{{ mediaError }}</small>
    </div>
  </div>

  <div class="room-alert" *ngIf="shouldStartCameraOff">
    <mat-icon>info</mat-icon>
    <div>
      <strong>Audio-first join applied</strong>
      <small>This room has more than {{ audioFirstThreshold }} invitees, so your camera starts off by default. You can enable it any time.</small>
    </div>
  </div>

  <div class="room-alert sharing" *ngIf="sharingScreen">
    <mat-icon>present_to_all</mat-icon>
    <div>
      <strong>You are presenting</strong>
      <small>Your screen is being shared to everyone in this room. Stop sharing when you are done.</small>
    </div>
  </div>

  <div class="room-layout">
    <section class="stage-panel">
      <div class="presentation-stage" *ngIf="isVideoRoom && activePresentation?.isPresenting">
        <div class="presentation-head">
          <strong>{{ activePresentation?.displayName }}</strong>
          <span>Presenting screen</span>
        </div>
        <video #presentationMedia autoplay playsinline></video>
      </div>

      <div class="stage-grid" [class.audio-only]="!isVideoRoom" [class.with-presentation]="isVideoRoom && activePresentation?.isPresenting">
        <article class="media-tile local" [class.presenting]="sharingScreen" [class.compact]="isVideoRoom && activePresentation?.isPresenting">
          <div class="tile-head">
            <strong>You</strong>
            <span>{{ sharingScreen ? 'Presenting screen' : (micEnabled ? 'Mic on' : 'Mic muted') }}</span>
          </div>
          <video *ngIf="isVideoRoom" #localMedia autoplay playsinline muted></video>
          <audio *ngIf="!isVideoRoom" #localMedia autoplay muted></audio>
          <div class="audio-avatar" *ngIf="!isVideoRoom">{{ currentUserName.charAt(0) }}</div>
        </article>

        <article class="media-tile remote" [class.compact]="isVideoRoom && activePresentation?.isPresenting" *ngFor="let participant of tileParticipants">
          <div class="tile-head">
            <strong>{{ participant.displayName }}</strong>
            <span>Connected</span>
          </div>
          <video *ngIf="isVideoRoom" [id]="'remote-video-' + participant.connectionId" autoplay playsinline></video>
          <audio *ngIf="!isVideoRoom" [id]="'remote-audio-' + participant.connectionId" autoplay></audio>
          <div class="audio-avatar remote" *ngIf="!isVideoRoom">{{ participant.displayName.charAt(0) }}</div>
        </article>
      </div>
    </section>

    <aside class="control-panel">
      <div class="control-card">
        <h3>Room Controls</h3>
        <div class="control-actions">
          <button mat-flat-button color="primary" (click)="toggleMic()">{{ micEnabled ? 'Mute Mic' : 'Unmute Mic' }}</button>
          <button mat-stroked-button *ngIf="isVideoRoom" (click)="toggleCamera()">{{ cameraEnabled ? 'Stop Camera' : 'Start Camera' }}</button>
          <button mat-stroked-button color="accent" *ngIf="isVideoRoom" (click)="toggleScreenShare()">
            {{ sharingScreen ? 'Stop Sharing' : 'Share Screen' }}
          </button>
        </div>
        <small class="control-hint" *ngIf="isVideoRoom">Screen share works best on desktop browsers with HTTPS.</small>
      </div>

      <div class="control-card chat-card">
        <div class="chat-head">
          <h3>Meeting Chat</h3>
          <span>{{ chatMessages.length }} messages</span>
        </div>
        <div #chatStream class="chat-stream" *ngIf="chatMessages.length; else noChatMessages">
          <div class="chat-item" *ngFor="let message of chatMessages">
            <div class="chat-meta">
              <strong>{{ message.createdByName }}</strong>
              <span>{{ message.createdAt | date:'shortTime' }}</span>
            </div>
            <p>{{ message.message }}</p>
          </div>
        </div>
        <ng-template #noChatMessages>
          <div class="empty-chat">No chat yet. Start the conversation here during the meeting.</div>
        </ng-template>
        <div class="chat-composer">
          <textarea [(ngModel)]="chatDraft" rows="3" placeholder="Type a message for everyone in the meeting" (keydown)="handleChatKeydown($event)"></textarea>
          <button mat-flat-button color="primary" type="button" [disabled]="chatSending || !chatDraft.trim()" (click)="sendChatMessage()">
            {{ chatSending ? 'Sending...' : 'Send' }}
          </button>
        </div>
      </div>

      <div class="control-card">
        <h3>Meeting Room</h3>
        <div class="meta-row">
          <span>Status</span>
          <strong>{{ room.status }}</strong>
        </div>
        <div class="meta-row">
          <span>Room code</span>
          <strong>{{ room.roomCode }}</strong>
        </div>
        <div class="meta-row">
          <span>Organizer</span>
          <strong>{{ room.createdByName || 'Unknown' }}</strong>
        </div>
      </div>

      <div class="control-card">
        <h3>Invitees</h3>
        <div class="attendee-list">
          <div class="attendee-row" *ngFor="let attendee of room.attendees">
            <strong>{{ attendee.staffName }}</strong>
            <small>{{ attendee.isOrganizer ? 'Organizer' : 'Attendee' }}</small>
          </div>
        </div>
      </div>
    </aside>
  </div>
</div>
